import Component, { Topic } from 'component';
import { replaceContent, assert, uuid, toNum } from 'utils';
import { CART_DRAWER_CONTENT_ID, ReqSection, ENTER_KEY_IDENTIFIER } from 'constants';
export const LINE_ITEM_DATA_ATTR = 'data-line-item';
export const NOTES_TEXT_DATA_ATTR = 'data-cart-notes-text';
export const MODAL_ID_ATTR = 'modal-id';
export const NOTES_OPEN_ID_ATTR = 'notes-open-checkbox';
export const NOTES_CLOSE_DATA_ATTR = 'data-notes-close-checkbox';
customElements.define('x-cart-drawer', class extends Component {
    constructor() {
        super();
        this.$element.content = this.querySelector('[data-cart-drawer-element="content"]');
        this.$element.notesOpen = this.querySelector('[data-cart-drawer-element="notes-open"]');
    }
    modal;
    TUID = null;
    closeNotesCheckbox = null;
    notesText = null;
    render() {
        this.modal = document.getElementById(this.getAttribute(MODAL_ID_ATTR));
        assert(this.modal, `Cart drawer is missing dialog element`);
        this.on(this, 'change', this.handleCartChange);
        this.notesText = this.querySelector(`[${NOTES_TEXT_DATA_ATTR}]`);
        if (this.notesText) {
            this.closeNotesCheckbox = this.querySelector(`[${NOTES_CLOSE_DATA_ATTR}]`);
            this.on(this.$element.notesOpen, 'keypress', this.handleEnterKeypress);
            this.on(this.closeNotesCheckbox, 'keypress', this.handleEnterKeypress);
        }
        this.sub(Topic.CART_UPDATE, ({ data, error, TUID }) => {
            if (this.TUID && this.TUID === TUID) {
                this.loading(false);
            }
            if (error) {
            }
            if (data) {
                const { sections, openDrawer } = data;
                const targetDoc = sections[ReqSection.CART_DRAWER];
                if (targetDoc && this.updateContent(targetDoc)) {
                    if (openDrawer) {
                        this.modal.open();
                    }
                }
            }
        }, { global: true });
    }
    loading(state) {
        this.classList.toggle('cart-drawer--loading', state);
    }
    async handleCartChange(e) {
        const target = e.target;
        if (!target) {
            return;
        }
        if (target.hasAttribute(NOTES_TEXT_DATA_ATTR)) {
            this.pub(Topic.CART_NOTES, target.value);
            return;
        }
        if (target.hasAttribute(NOTES_CLOSE_DATA_ATTR)) {
            this.$element.notesOpen.checked = false;
            target.checked = false;
            return;
        }
        const lineItem = target.getAttribute(LINE_ITEM_DATA_ATTR);
        if (!lineItem) {
            return;
        }
        const value = toNum(target.value);
        if (value === null) {
            console.error('Invalid value');
            return;
        }
        this.TUID = uuid();
        this.pub(Topic.CART_CHANGE, {
            TUID: this.TUID,
            id: lineItem,
            qty: value
        });
        this.loading(true);
    }
    updateContent(updatedDoc) {
        const updatedContent = updatedDoc.getElementById(CART_DRAWER_CONTENT_ID);
        if (!updatedContent) {
            console.error('No cart drawer container within response section');
            return false;
        }
        replaceContent(this.$element.content, updatedContent, true);
        return true;
    }
    handleEnterKeypress(e) {
        if (e.key === ENTER_KEY_IDENTIFIER) {
            const target = e.currentTarget;
            e.preventDefault();
            e.stopPropagation();
            target.checked = !target.checked;
            if (target !== this.$element.notesOpen) {
                this.$element.notesOpen.checked = false;
            }
            else {
                this.notesText?.focus();
            }
        }
    }
});
